import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NimbusChartsModule } from '@nimbus-library/features/charts/nimbus-charts.module';
import { ChatMessagePieComponent } from '@nimbus-global/features/chat-chart/components/chat-message-pie/chat-message-pie.component';

@NgModule({
  declarations: [ChatMessagePieComponent],
  imports: [CommonModule, NimbusChartsModule],
  exports: [ChatMessagePieComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChatChartModule {}
